import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';


// const useStyles = makeStyles((theme) => ({
//     // root: {
//     //     display: 'flex',
//     //     '& > * + *': {
//     //         marginLeft: theme.spacing(2),
//     //     },
//     // },
// }));

export default function ProgressCircle() {
    // const classes = useStyles();

    return (
        <div style={{ position: 'absolute', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div >
                <CircularProgress />
                <h3 style={{ marginLeft: '-60px' }} >Generating articles</h3>
            </div>
        </div>

    );
}